import { FC } from 'react';

import {
  Button,
  Card,
  Details,
  Form,
  Stack,
  Typography,
  useFormControl,
} from '@wearehelpful/ui-kit';
import { BDTO } from '@helpful/network';
import { useTranslation } from '@wearehelpful/ui-localization';

import { TherapistDetails } from '../TherapistDetails';

import { AVATAR_SIZE } from './TherapistCard.const';

interface TherapistCardProps {
  item: BDTO.TherapistItem;
}

export const TherapistCard: FC<TherapistCardProps> = ({ item }) => {
  const { id, picture, fullName, title, description } = item;

  const { t } = useTranslation();

  const [, { setValue }] = useFormControl<string>({
    name: 'therapist',
    watch: false,
  });

  return (
    <Card variant="flat" divider>
      <Card.Avatar src={picture} dimantion={AVATAR_SIZE} />
      <Card.Header>
        <Card.Title>
          {t('forms.fullNameWithTitle', {
            fullName,
            title,
          })}
        </Card.Title>
      </Card.Header>
      <Card.Content whiteSpace="break-spaces">
        <Stack spacing={2}>
          <Typography variant="p2">{description}</Typography>
          <Stack direction="horizontal" spacing={4}>
            <Form.RadioToggle.Item value={id}>
              {t('actions.select')}
            </Form.RadioToggle.Item>
            <Details>
              <Details.Toggle block={false} variant="secondary" size="s">
                {t('actions.readBio')}
              </Details.Toggle>
              <Details.Content
                footer={({ close }) => (
                  <Button
                    onClick={() => {
                      setValue(id);
                      close();
                    }}
                  >
                    {t('actions.select')}
                  </Button>
                )}
              >
                <TherapistDetails id={id} />
              </Details.Content>
            </Details>
          </Stack>
        </Stack>
      </Card.Content>
    </Card>
  );
};
